import React from 'react';
import {ReactSVG} from "react-svg";
import {getPublicImagePath} from "@nutastic/nutastic-react-app";

const Footer = () => {
    const componentClass = 'footer';

    return <footer className={componentClass}>
        <div className="container">
            <ReactSVG src={getPublicImagePath('infinity.svg')} className='footer__infinity' />
            <h3>let's build <i>UP</i> together!</h3>
            <div className="footer__icons">
                <a href="https://www.instagram.com/unmaskpurpose/" target="_blank" rel="noreferrer"><i className="ion-logo-instagram" /></a>
                <a href="https://podcasts.apple.com/us/podcast/unmask-purpose-podcast/id1596936605" target="_blank" rel="noreferrer"><i className="ion-logo-apple" /></a>
                <a href="https://www.youtube.com/@UnmaskPurposePod" target="_blank" rel="noreferrer"><i className="ion-logo-youtube" /></a>
                <a href="https://open.spotify.com/show/2mXDUWHBal8r3qCjTnk3Wi?si=e2979c66e0344990" target="_blank" rel="noreferrer"><i className="ion-logo-rss" /></a>
                <a href="mailto:hello@unmaskpurpose.com?subject=Unmask With Us" target="_blank" rel="noreferrer"><i className="ion-ios-mail" /></a>
            </div>
            <div className="team-images">
                <a href="https://larondajames.com/home" target="_blank" rel="noreferrer">
                    <img src={getPublicImagePath('avi--lj.png')} alt="LaRonda James | Unmask Purpose" />
                </a>
                <a href="https://www.instagram.com/joyeux_bae/" target="_blank" rel="noreferrer">
                    <img src={getPublicImagePath('avi--yanni.png')} alt="Joyana Foster | Unmask Purpose" />
                </a>
            </div>
        </div>
    </footer>;
};

export default Footer;
